import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { encryptStorage } from '../slices/authSlice'

const WebViewPage = () => {
	const [_sessionStorage, setSessionStorage] = useState()
	const [localStr, setLocalStr] = useState()
	const [rft, setRft] = useState()

	useEffect(() => {
		setSessionStorage(sessionStorage.getItem('fakeLogin'))
		setLocalStr(encryptStorage.getItem('znxpefwwcs'))
		setRft(encryptStorage.getItem('rft'))
	}, [])

	return (
		<div>
			<h1>This is web view</h1>
			<div className="mt-10">{_sessionStorage ? _sessionStorage : '-'}</div>
			<div className="mt-10">{localStr ? JSON.stringify(localStr, null, 3) : '-'}</div>
			<div className="mt-10">{rft ? JSON.stringify(rft, null, 3) : '-'}</div>

			<div className="mt-5">
				<Link to="/crude/market-update">Crude Market Update</Link>
			</div>
		</div>
	)
}

export default WebViewPage
